(() => {
  const revealSelector = ".pp-story-reveal";

  function revealImmediately(root) {
    root.querySelectorAll(revealSelector).forEach((item) => {
      item.classList.add("is-visible");
    });
  }

  function initializeOurStory(root = document) {
    const items = root.querySelectorAll(revealSelector);
    if (!items.length) return;

    const reducedMotion = window.matchMedia(
      "(prefers-reduced-motion: reduce)"
    ).matches;

    if (!("IntersectionObserver" in window) || reducedMotion) {
      revealImmediately(root);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting) return;

          entry.target.classList.add("is-visible");
          currentObserver.unobserve(entry.target);
        });
      },
      {
        threshold: 0.14,
        rootMargin: "0px 0px -10% 0px",
      }
    );

    items.forEach((item) => {
      if (item.dataset.ppRevealInitialized === "true") return;
      item.dataset.ppRevealInitialized = "true";
      observer.observe(item);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", () => {
      initializeOurStory(document);
    });
  } else {
    initializeOurStory(document);
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeOurStory(event.target);
  });
})();